var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "item-line" }, [_vm._v("活动提报信息")]),
    _c(
      "div",
      { staticClass: "budgetBox bodyBox" },
      [
        _c(
          "a-form-model",
          {
            ref: "signUpForm",
            staticClass: "UniformCss",
            attrs: {
              inline: true,
              model: _vm.data,
              rules: _vm.rules,
              "label-col": { span: 8, style: { width: "100px" } },
            },
          },
          [
            _c(
              "a-row",
              [
                _c(
                  "a-col",
                  { attrs: { span: 6 } },
                  [
                    _c(
                      "a-form-model-item",
                      { staticClass: "sign-tiem", attrs: { label: "经理部" } },
                      [
                        _c("a-input", {
                          attrs: { disabled: "", placeholder: "" },
                          model: {
                            value: _vm.managementDeptName,
                            callback: function ($$v) {
                              _vm.managementDeptName = $$v
                            },
                            expression: "managementDeptName",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: false,
                        expression: "false",
                      },
                    ],
                    attrs: { span: 6 },
                  },
                  [
                    _c(
                      "a-form-model-item",
                      {
                        staticClass: "sign-tiem widthHuo",
                        attrs: { label: "经销商", "label-col": { span: 3 } },
                      },
                      [
                        _c("a-input", {
                          attrs: { disabled: "", placeholder: "请输入经销商" },
                          model: {
                            value: _vm.data.dealerName,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "dealerName", $$v)
                            },
                            expression: "data.dealerName",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 6 } },
                  [
                    _c(
                      "a-form-model-item",
                      {
                        staticClass: "sign-tiem widthHuo",
                        attrs: { label: "经销商", "label-col": { span: 3 } },
                      },
                      [
                        _c("a-input", {
                          attrs: { disabled: "", placeholder: "请输入经销商" },
                          model: {
                            value: _vm.data.dealerShortName,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "dealerShortName", $$v)
                            },
                            expression: "data.dealerShortName",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "a-col",
                  { attrs: { span: 6 } },
                  [
                    _c(
                      "a-form-model-item",
                      {
                        staticClass: "act-item",
                        attrs: { label: "计划开始日期", prop: "planStartTime" },
                      },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            "value-format": "yyyy-MM-dd HH:mm:ss",
                            type: "date",
                            placeholder: "选择日期",
                            "picker-options": _vm.pickerOptions,
                          },
                          model: {
                            value: _vm.data.planStartTime,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "planStartTime", $$v)
                            },
                            expression: "data.planStartTime",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "a-col",
                  { attrs: { span: 6 } },
                  [
                    _c(
                      "a-form-model-item",
                      {
                        staticClass: "sign-tiem",
                        attrs: { label: "计划结束日期", prop: "planEndTime" },
                      },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            "value-format": "yyyy-MM-dd HH:mm:ss",
                            type: "date",
                            placeholder: "选择日期",
                            "picker-options": _vm.pickerOptions,
                          },
                          model: {
                            value: _vm.data.planEndTime,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "planEndTime", $$v)
                            },
                            expression: "data.planEndTime",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(_vm.getFormByActivity(_vm.activity.threeLevelName), {
              ref: "activityForm",
              tag: "component",
              attrs: { activity: _vm.activity, formData: _vm.data },
            }),
            _c(
              "a-row",
              [
                _c(
                  "a-col",
                  { staticStyle: { height: "auto" }, attrs: { span: 12 } },
                  [
                    typeof this.data.planApplyCode !== "undefined"
                      ? _c(
                          "a-form-model-item",
                          {
                            staticClass: "sign-tiem",
                            attrs: {
                              label: "计划方案",
                              "label-col": { span: 3 },
                            },
                          },
                          [
                            _c(
                              "el-upload",
                              {
                                ref: "uploadFile",
                                staticClass: "upload-demo",
                                attrs: {
                                  action: "",
                                  "before-upload": _vm.beforeUpload,
                                  "on-preview": _vm.onPreviewFun,
                                  "on-change": _vm.handleChange,
                                  "on-remove": _vm.handleRemove,
                                  "before-remove": _vm.beforeRemove,
                                  "http-request": _vm.uploadHttpRequest,
                                  "auto-upload": false,
                                  "file-list": _vm.fileList,
                                },
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      slot: "trigger",
                                      icon: "el-icon-circle-plus-outline",
                                      size: "small",
                                      type: "primary",
                                    },
                                    slot: "trigger",
                                  },
                                  [_vm._v("选择文件")]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "el-upload__tip",
                                    attrs: { slot: "tip" },
                                    slot: "tip",
                                  },
                                  [_vm._v("一次只能上传一个文件，且不超过20M")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    typeof this.data.planApplyCode === "undefined"
                      ? _c(
                          "a-form-model-item",
                          {
                            staticClass: "sign-tiem",
                            attrs: {
                              label: "计划方案",
                              "label-col": { span: 3 },
                            },
                          },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  icon: "el-icon-circle-plus-outline",
                                  type: "primary",
                                  size: "small",
                                },
                                on: { click: _vm.uploadClick },
                              },
                              [_vm._v("选择文件")]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }